<template>
  <div class="summary-card">
    <div class="summary-header">
      <div class="title-area">
        <van-icon name="todo-list-o" size="20" class="icon-main" />
        <span class="main-title">{{ $t('week_task') }}</span>
      </div>
      <div class="stats-area">
        <span class="num">{{ totalCount }}</span> <span class="label">{{ $t('total_task') }}</span>
        <span class="divider">|</span>
        <span class="num">{{ completedCount }}</span> <span class="label">{{ $t('completed_task') }}</span>
      </div>
    </div>
    <!-- <div class="summary-desc">完成任务 3 / 10 · KPI达成率 30%</div> -->
    <div class="action-row" style="margin-bottom: 20px;">
      <div class="progress-track">
        <div class="progress-bar" :style="{ width: completionPercentage + '%' }">
          <span class="progress-text">{{ completionPercentage }}%</span>
        </div>
      </div>
      <div class="go-btn" @click="goToTasks">{{ $t('go_to_complete') }} <van-icon name="arrow" /></div>
    </div>

    <template v-if="isLoading || (events && events.length > 0)">
      <div style="border-top: 1px dashed #eee; margin: 0 -16px; padding-top: 16px;"></div>

      <div v-if="isLoading" class="priority-block-content" style="text-align: center; padding: 20px 0; min-height: 30px; display: flex; align-items: center; justify-content: center;">
        <van-loading size="24px" vertical color="#bbb" text-size="13px">{{ $t('loading_tasks_text') }}</van-loading>
      </div>

      <div v-else class="priority-block-content">
        <!-- Removed card-top-tags as requested -->
        <div v-for="(event, index) in events" :key="index" class="event-item" style="margin-bottom: 10px;">
          <div style="display: flex; align-items: flex-start; justify-content: space-between;" @click="goTaskDetail(event)">
            <div class="card-main-title" style="margin-bottom: 0; flex: 1; padding-right: 16px;">
              <span class="type-badge">{{ eventTypeText(event.event_type) }}</span>
              {{ event.campaign_event_name }}
            </div>

            <div v-if="event.topTask" class="doctor-info-right" style="flex-shrink: 0; display: flex; flex-direction: column; align-items: flex-end;">
              <div class="avatar-group" style="position: relative; height: 30px; margin-bottom: 6px; display: flex; justify-content: flex-end;" :style="{ width: ((event.topTasks ? event.topTasks.slice(0, 3).length : 0) - 1) * 16 + 30 + 'px' }">
                <div
                  v-for="(task, idx) in (event.topTasks ? event.topTasks.slice(0, 3) : [])"
                  :key="idx"
                  class="avatar-circle"
                  :style="{ position: 'absolute', right: `${((event.topTasks ? event.topTasks.slice(0, 3).length : 0) - 1 - idx) * 18}px`, zIndex: 3 - idx, border: '1px solid #fff', width: '30px', height: '30px', borderRadius: '50%', background: '#f0f0f0', overflow: 'hidden' }"
                >
                  <img
                    :src="getAvatarBySex(task.sex)"
                    style="width: 100%; height: 100%; object-fit: cover; opacity: 0.5;"
                  />
                </div>
              </div>
              <div class="name-line" style="font-size: 12px; color: #666; font-weight: normal; display: flex; align-items: center; justify-content: flex-end;">
                <span>{{ event.topTask.physician_name }}</span>
                <span v-if="event.doctorCount > 1" style="margin-left: 2px;">{{ $t('task_more_doctors', { count: event.doctorCount }) }}</span>
                <van-icon name="arrow" style="margin-left: 2px;" />
              </div>
            </div>

            <div v-else class="doctor-info-right" style="flex-shrink: 0; display: flex; align-items: center; justify-content: flex-end; height: 30px;font-size: 14px; color: #666;">
              <van-icon name="arrow" />
            </div>
          </div>

          <div v-if="index < events.length - 1" style="border-top: 1px dashed #f5f5f5; margin: 10px -10px 0;"></div>
        </div>
        <div style="border-top: 1px solid #eee; margin: 0 -16px;"></div>
        <div class="card-footer-link" style="padding-top: 12px;" @click="goToTasks">
          {{ $t('go_to_all_tasks') }} <van-icon name="arrow" />
        </div>
      </div>
    </template>

    <div v-else class="priority-block-content" style="padding-top: 16px;">
      <div style="border-top: 1px solid #eee; margin: 0 -16px;"></div>
      <div class="card-footer-link" style="margin-top: 12px;" @click="goToTasks">
        {{ $t('go_to_all_tasks') }} <van-icon name="arrow" />
      </div>
    </div>
  </div>
</template>

<script>
import { Icon, Loading, Toast } from 'vant';
import { getPhysicianContentSend, getContentById } from '@/api/content';
import { executeTask, reExecuteTask } from '@/api/nba';
import { wecomSDK } from '@/utils/wecom';
import { selectRecommendedWording } from '@/utils/recommendedWording';

export default {
  name: 'TaskSummary',
  components: {
    [Icon.name]: Icon,
    [Loading.name]: Loading
  },
  props: {
    totalCount: {
      type: Number,
      default: 0
    },
    completedCount: {
      type: Number,
      default: 0
    },
    events: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    userId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      portraitMale: require('@/assets/lundbeck/avatar-male.png'),
      portraitFemale: require('@/assets/lundbeck/avatar-female.png'),
      defaultAvatar: require('@/assets/lundbeck/avatar-unknown.png')
    };
  },
  computed: {
    completionPercentage() {
      if (this.totalCount === 0) return 0;
      return Math.round((this.completedCount / this.totalCount) * 100);
    }
  },
  methods: {
    getAvatarBySex(sex) {
      if (['男', 'Male', this.$t('male')].includes(sex)) {
        return this.portraitMale;
      }
      if (['女', 'Female', this.$t('female')].includes(sex)) {
        return this.portraitFemale;
      }
      return this.defaultAvatar;
    },
    eventTypeText(type) {
      switch (type) {
        case 'conference':
          return this.$t('task_type_conference');
        case 'segment':
        case 'survey':
          return this.$t('task_type_segment');
        case 'hcp-survey':
          return this.$t('task_type_hcp_survey');
        case 'visit':
        case 'call':
          return this.$t('task_type_call');
        case 'content':
          return this.$t('task_type_content');
        default:
          return this.$t('task_type_other');
      }
    },
    goToTasks() {
      this.$emit('go-tasks');
    },
    goToDoctorDetail(task) {
      this.$emit('go-detail', task);
    },
    goTaskDetail(event) {
      this.$emit('go-tasks', event);
    },
    planVisit(task) {
      this.$emit('plan-visit', task);
    },
    fillSurvey(task) {
      this.$emit('fill-survey', task);
    },
    async sendTask(task) {
      if (!task) return;

      const toast = Toast.loading({
        duration: 10000,
        forbidClick: true,
        message: this.$t('loading')
      });

      try {
        const res = await getContentById(task.content_id);
        // Clear loading toast immediately after content is fetched to avoid blocking subsequent Dialogs
        toast.clear();

        if (res && res.value && res.value.length > 0) {
          const forwardContent = res.value[0];

          if (forwardContent.recommended_wording) {
            try {
              const wordingToCopy = await selectRecommendedWording(forwardContent.recommended_wording, {
                title: this.$t('recommended_wording'),
                confirmButtonText: this.$t('copy_wording'),
                cancelButtonText: this.$t('skip'),
              });

              if (wordingToCopy) {
                const success = await wecomSDK.copyToClipboard(wordingToCopy);
                if (!success) {
                  Toast.fail(this.$t('copy_failed'));
                }
              }
            } catch (err) {
              console.log(err);
            }
          }

          // Use non-blocking toast for sending process to allow interaction with "Doctor Bind" dialog if it appears
          const sendingToast = Toast.loading({
            duration: 10000,
            forbidClick: false,
            message: this.$t('sending')
          });

          const success = await wecomSDK.shareWechatMessage({
            content_id: task.content_id,
            sender_user_id: localStorage.getItem('user_id'),
            sender_user_name: localStorage.getItem('user_name'),
            sender_territory_id: localStorage.getItem('territory_id'),
            receiver_physician_id: task.physician_id,
            send_time: new Date(),
            title: forwardContent.content_name,
            description: forwardContent.description,
            wx_logo: forwardContent.wx_logo,
          });

          sendingToast.clear();

          if (success) {
            console.log('Send task:', task);
            if (task.campaign_event_execution_id) {
              reExecuteTask(task.campaign_event_execution_id, 'accept', task.campaign_event_id, task.physician_id, this.userId, localStorage.getItem('user_name') || '', localStorage.getItem('territory_id') || '', localStorage.getItem('role_id') || '')
                .then(async () => {
                  Toast.success(this.$t('task_resent'));
                  this.$emit('refresh');
                })
                .catch(error => {
                  console.error('Failed to re-execute task:', error);
                  Toast.fail(this.$t('re_send_failed'));
                });
            } else {
              executeTask('accept', task.campaign_event_id, task.physician_id, this.userId, localStorage.getItem('user_name') || '', localStorage.getItem('territory_id') || '', localStorage.getItem('role_id') || '')
                .then(async () => {
                  Toast.success(this.$t('task_executed'));
                  this.$emit('refresh');
                })
                .catch(error => {
                  console.error('Failed to accept task:', error);
                  Toast.fail(this.$t('send_content_failed'));
                });
            }
          }
        } else {
          toast.clear();
          Toast.fail(this.$t('get_content_failed'));
        }
      } catch (err) {
        toast.clear();
        console.error('Forward error:', err);
        Toast.fail(this.$t('forward_failed'));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.summary-card {
  background: white;
  border-radius: 16px;
  padding: 16px 16px 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  margin-bottom: 24px;
}

.summary-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  .title-area {
    display: flex;
    align-items: center;

    .icon-main {
      margin-right: 6px;
      font-weight: bold;
    }

    .main-title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }
  }

  .stats-area {
    font-size: 14px;

    .num {
      font-weight: bold;
      font-size: 18px;
      color: #333;
    }

    .label {
      font-size: 12px;
      color: #666;
      margin-left: 2px;
    }

    .divider {
      color: #eee;
      margin: 0 8px;
    }
  }
}

.summary-desc {
  font-size: 13px;
  color: #666;
  margin-bottom: 12px;
}

.action-row {
  display: flex;
  align-items: center;
  gap: 12px;

  .progress-track {
    flex: 1;
    height: 32px;
    background: linear-gradient(90deg, #fceceb 0%, #ffffff 100%);
    border-radius: 16px;
    position: relative;
    overflow: hidden;
    border: 1px solid #fceceb;

    .progress-bar {
      height: 100%;
      background: linear-gradient(90deg, #ff8e8e 0%, #aa341b 100%);
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      .progress-text {
        color: white;
        font-size: 14px;
        font-weight: bold;
        position: absolute;
        right: 12px;
      }
    }
  }

  .go-btn {
    background: white;
    color: #aa341b;
    border: 1.5px solid #aa341b;
    padding: 0 16px;
    height: 30px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    white-space: nowrap;

    .van-icon {
      margin-left: 4px;
      font-size: 12px;
    }
  }
}

.section-header-simple {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #aa341b;
  font-weight: 500;
  margin-bottom: 12px;
  padding-left: 4px;
}

.priority-block-content {
  padding-top: 4px;

  .card-top-tags {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    .tag-red {
      background: #d1402b;
      color: white;
      font-size: 11px;
      padding: 2px 8px;
      border-radius: 4px;
      font-weight: bold;
    }

    .tag-info {
      font-size: 12px;
      color: #999;
      display: flex;
      align-items: center;

      .van-icon {
        margin-left: 2px;
      }
    }
  }

  .card-main-title {
    font-size: 12px;
    font-weight: bold;
    color: #333;
    line-height: 1.5;
    margin-bottom: 16px;

    .type-badge {
      display: inline-block;
      padding: 1px 6px;
      border-radius: 4px;
      background-color: #fdf5f2;
      color: #aa341b;
      font-size: 10px;
      font-weight: normal;
      margin-right: 6px;
      vertical-align: 2px;
      border: 1px solid rgba(170, 52, 27, 0.2);
    }
  }

        // 移除旧的特定样式，保留通用即可

  .card-footer-link {
    padding-top: 6px;
    text-align: center;
    font-size: 12px;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;

    .van-icon {
      margin-left: 4px;
      color: #999;
    }
  }
}
</style>
